import { render, staticRenderFns } from "./HouseholdAdmin.vue?vue&type=template&id=09ca3360&scoped=true&"
import script from "./HouseholdAdmin.vue?vue&type=script&lang=js&"
export * from "./HouseholdAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HouseholdAdmin.vue?vue&type=style&index=0&id=09ca3360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca3360",
  null
  
)

export default component.exports